import { render } from "./viewInfo.vue?vue&type=template&id=67f2258e&scoped=true"
import script from "./viewInfo.vue?vue&type=script&lang=js"
export * from "./viewInfo.vue?vue&type=script&lang=js"

import "./viewInfo.vue?vue&type=style&index=0&id=67f2258e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f2258e"]])

export default __exports__